import { render, staticRenderFns } from "./handOrder.vue?vue&type=template&id=480663c3&scoped=true&"
import script from "./handOrder.vue?vue&type=script&lang=js&"
export * from "./handOrder.vue?vue&type=script&lang=js&"
import style0 from "./handOrder.vue?vue&type=style&index=0&id=480663c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480663c3",
  null
  
)

export default component.exports